import {Component, Input} from '@angular/core';
import {ThingFeatureLoopInterface} from '@app/app/shared/interfaces/thing/thing-feature-loop.interface';

@Component({
  templateUrl: './park-feature-loop-controls.html',
  selector: 'park-feature-loop-controls'
})

export class ParkFeatureLoopControlsComponent {
  @Input() public featureloops: ThingFeatureLoopInterface[];
  @Input() public parkId: any;
  @Input() public id: any;
  @Input() public color: string;

  objectKeys = Object.keys;

  public elements(el) {
    return Object.keys(el).filter((eId: any) => {
      return !el[eId].hasOwnProperty('sensortype') || !['WD', 'AN', 'DP', 'WT'].includes(el[eId].sensortype.toUpperCase());
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/controls/filtration/feature-loop/park-feature-loop-controls.component.ts